exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js!../node_modules/bootstrap/dist/css/bootstrap.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js!../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js!../node_modules/@fortawesome/fontawesome-free/css/all.css"), "");

// module
exports.push([module.id, "body{background-color:#d2ddfb;background-image:url(\"/static/tower.jpg\");background-attachment:fixed;background-size:cover}img{max-width:100%}.main-blue{color:#273c73}.bg-dark-blue{background:#141e3a}.bg-main-blue{background:#273c73}.mb-80{margin-bottom:80px!important}textarea{resize:none;min-height:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69c1e584","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 34
// module chunks = 0